import React, {useEffect} from "react";
import {Controller, useForm} from "react-hook-form";
import InputEx from "../../../components/wrapperComponents/InputEx";
import RadioInput from "../../../components/RadioInput";
import FormButtons from "../../../components/FormButtons";
import DatePickerWrapper from "../../../components/DataPickerWrapper";
import * as Validation from "@utilities/validationRules";
import {ComboBoxSettoreCCNL} from "../../../components/comboBox/ComboBoxInquadramento";
import {useGetCCNLQuery} from "@commons/features/sistema/tabelleDiSistema.api";
import TextAreaEx from "../../../components/wrapperComponents/TextAreaEx";
import {CCNLRecord} from "@commons/mapping/SettoriCCNL";
import {IntegerInputEx} from "../../../components/wrapperComponents/IntegerInputEx";


interface CCNLEditorProps {
    defaultValues: CCNLRecord,
    resource: CCNLRecord,
    onSubmit: (formData: CCNLRecord) => void,
    onCancel: () => void,
}

const CCNLProprietaEditor: React.FC<CCNLEditorProps> = ({defaultValues, resource, onSubmit, onCancel}) => {

    const currentValues: CCNLRecord = {
        ...defaultValues,
        ...resource,
        tipologiaCCNL: resource ? (resource.codContrattoUNILAV === '*' ? 'VECCHIO' : 'NUOVO') : defaultValues.tipologiaCCNL,
    };

    const {register, handleSubmit, reset, formState: {errors}, control, watch} = useForm<CCNLRecord>({defaultValues: {numMensilita: 0} as CCNLRecord});

    useEffect(() => reset(currentValues), [resource]);

    function onHandleSubmit(newValues: CCNLRecord) {
        onSubmit({...newValues, tipologiaCCNL: undefined})
    }

    const disableField: boolean | undefined = watch('tipologiaCCNL') === 'VECCHIO';

    const {data: dataCCNL, isLoading: isLoadingCCNL} = useGetCCNLQuery();

    function resetCodUnilav() {
        if (watch('tipologiaCCNL') === 'VECCHIO') {
            resource.codContrattoUNILAV = '*'
        }
    }

    const watchDescrizione = watch('descrizione');
    const descrizioneLength = watchDescrizione ? watchDescrizione.length : 0

    return <>
        <form onSubmit={handleSubmit(onHandleSubmit)}>
            <div className="flexRowWrapFull">
                <div className="sm2-6P">
                    <label htmlFor="tipologia" className="block font-medium text-sm">Tipologia</label>
                    <RadioInput label="Vecchio ordinamento" className="mt-2" id="ord_vecchio"
                                name="tipologiaCCNL"
                                value="VECCHIO"
                                register={register}
                                onChange={resetCodUnilav}/>
                    <RadioInput label="Nuovo ordinamento" id="ord_nuovo"
                                name="tipologiaCCNL"
                                value="NUOVO"
                                register={register}/>
                </div>
                <div className="sm2-6P">
                    <InputEx label="Codice UNILAV" id="contrattoUNILAV"
                             name="codContrattoUNILAV"
                             register={register} registerOptions={Validation.required} errors={errors} maxLength={6}
                             disabled={disableField}/>
                </div>
                <div className="sm2-6P">
                    <InputEx label="Codice inps" id="contrattoINPS"
                             name="codContratto"
                             register={register} registerOptions={Validation.required} errors={errors} maxLength={6}/>
                </div>
            </div>
            <div className="flexRowWrapFull">
                <div className="sm2-6P">
                    <ComboBoxSettoreCCNL<CCNLRecord> label="CCNL settore" name="settore"
                                                     data={dataCCNL} isLoading={isLoadingCCNL}
                                                     defaultValue={defaultValues.settore}
                                                     control={control}
                    />
                </div>
                <div className="sm2-6P">
                    <IntegerInputEx label="Numero mensilità" name="numMensilita" control={control} min={1} max={14}/>
                </div>
                <div className="sm2-6P">
                </div>
            </div>

            <div className="flexRowWrapFull mt-2 mb-2">
                <TextAreaEx name="descrizione" id="descrizione" label="Descrizione" defaultValue={defaultValues.descrizione}
                            rows={4} register={register} registerOptions={Validation.required} errors={errors} maxLength={2000}
                            textLength={descrizioneLength} totalChars={2000}
                />
            </div>

            <fieldset className="flexRowWrapFull border border-gray-200 pb-3 px-3">
                <legend className="px-2">Validit&agrave;</legend>
                <div className="sm1-3P">
                    <label className="block text-sm font-semibold mb-1" htmlFor="validitaInizio">Data inizio</label>
                    <Controller name="inizioValidita" control={control} defaultValue={defaultValues.inizioValidita}
                                render={({field: {value, onChange}, fieldState, formState}) =>
                                    (<DatePickerWrapper fieldState={fieldState} value={value} onChange={onChange} enabled/>)
                                }
                    />
                </div>
                <div className="sm1-3P">
                    <label className="block text-sm font-semibold mb-1" htmlFor="fineValidita">Data fine</label>
                    <Controller name="fineValidita" control={control} defaultValue={defaultValues.fineValidita}
                                render={({field: {value, onChange}, fieldState, formState}) =>
                                    (<DatePickerWrapper fieldState={fieldState} value={value} onChange={onChange} enabled/>)
                                }
                    />
                </div>
            </fieldset>

            <FormButtons onCancel={onCancel} resource={resource}/>

        </form>
    </>
}

export default CCNLProprietaEditor;
